<template>
  <div class="content-of-main-section parallax" :style="'background-image: url('+`${parallaxImage}`+');'">
    <div class="header-text">
      <slot name="p-1"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "S101",
  props:['parallaxImage']
}
</script>

<style scoped>
.content-of-main-section {
  position: relative;
  text-align: center;
  width: 100%;
  height: 600px;
}

.header-text {
  position: absolute;
  width: 100%;
  top: 35%;
  z-index: 5;
}

.content-of-main-section:after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.8;
  background-image: linear-gradient(0turn, transparent, var(--primary), transparent);
}

.content-of-main-section img {
  max-width: 100%;
  transition: all 0.3s;
  display: block;
  width: 100%;
  object-fit: cover;
}
.parallax {
  min-height: 600px;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
}
</style>